import Apify from '@module/apify';

export default Apify({
  getInvitations: {
    path: '/api/v4/invitations',
    method: 'GET',
  },

  createInvitation: {
    path: '/api/v4/invitations',
    method: 'POST',
  },

  getInvitation: {
    path: '/api/v4/invitations/{token}',
    pathExt: true,
    method: 'GET',
  },

  updateInvitation: {
    path: '/api/v4/invitations/{token}',
    pathExt: true,
    method: 'PUT',
  },

  deleteInvitation: {
    path: '/api/v4/invitations/{invitationId}',
    pathExt: true,
    method: 'DELETE',
  },
});
